import Employee from './Employee'
import Request from './Request'
export class CompleteRequestsRequest {
    Employee: Employee;
    ValidateCompletionNumbers?: boolean;
    SaveCompletionNumbers?: boolean;
    Requests: Request[];
}

export default CompleteRequestsRequest;